(() => {
  'use strict';
  // Контент статьи рендерится сервером: article.php?slug=<slug> → seo_articles.
  // Тело статьи и блок «Другие статьи» заполняются в article_content.php из БД.
  // Если статьи нет (битый slug) — article.php делает 301 на blog.php,
  // поэтому JS-fallback с хардкод-статьями больше не нужен (удалён 2026-06-08).

  /* ── Быстрый звонок из сайдбара ── */
  const sbBtn = document.getElementById('sbCallBtn');
  if (!sbBtn) return;

  sbBtn.addEventListener('click', async () => {
    const phone = document.getElementById('sbPhone');
    if (!phone || !phone.value.trim()) return;

    // lead-delivery 5.1 (152-ФЗ): согласие обязательно. Без галки — submit заблокирован,
    // consent_main НЕ уходит (send.php → 422). Только отмеченный чекбокс = информированное согласие.
    const consentEl = document.getElementById('sbConsent');
    if (!consentEl || !consentEl.checked) {
      const lbl = consentEl && consentEl.closest('.form-checkbox');
      if (lbl) { lbl.style.color = 'var(--error)'; setTimeout(() => { lbl.style.color = ''; }, 2500); }
      if (consentEl) consentEl.focus();
      return;
    }

    const titleEl = document.getElementById('articleTitle');
    // lead-delivery 5.1: успех показываем ТОЛЬКО при res.ok — иначе тихая потеря лида.
    let resOk = false;
    try {
      const res = await fetch('/send.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          _hp: '',
          name: 'Читатель блога',
          phone: phone.value.trim(),
          consent_main: '1',
          service: 'Звонок из статьи',
          _source: 'Блог — статья ' + ((titleEl && titleEl.textContent) || '').slice(0, 50),
          _csrf: window._csrfToken || ''
        })
      });
      resOk = res.ok;
      if (!res.ok) console.warn('[article] send failed:', res.status);
    } catch (e) { console.warn('[article] send error:', e); }

    if (!resOk) {
      if (typeof showToast === 'function') showToast('Ошибка отправки. Попробуйте позже.', 'warning');
      return;
    }
    // Учёт заявок 1.1: цель в Метрике — ТОЛЬКО на успешном ответе (не на клике),
    // иначе счётчик считает намерения, а не заявки. Цель `form_callback` уже
    // заведена; страница-источник различима параметром `source`.
    if (window.ymGoal) window.ymGoal('form_callback', { source: 'article' });
    const ok = document.getElementById('sbOk');
    if (ok) ok.style.display = 'block';
  });
})();
